/*
 * Copyright (c) 2025 Sila Artificial Intelligence Research LLC
 * A DA Holding Ltd Company
 * All rights reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL
 * This software and its documentation are proprietary to Sila Artificial
 * Intelligence Research LLC. Unauthorized copying, distribution, or use
 * of this software is strictly prohibited.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */

import React from 'react';

interface SimpleBrandSelectorProps {
  brands: any[];
  selectedBrand: string;
  onBrandSelect: (brandId: string) => void;
  className?: string;
}

/**
 * Simple single-select brand selector
 */
const SimpleBrandSelector: React.FC<SimpleBrandSelectorProps> = ({
  brands,
  selectedBrand,
  onBrandSelect,
  className = ''
}) => {
  if (!brands || brands.length === 0) {
    return (
      <div className={`${className}`}>
        <p className="text-text-muted">Loading brands...</p>
      </div>
    );
  }

  return (
    <div className={`${className}`}>
      <select
        value={selectedBrand}
        onChange={(e) => onBrandSelect(e.target.value)}
        className="w-full px-4 py-2 bg-background-secondary border border-[var(--border)] rounded-lg text-foreground focus:outline-none focus:border-primary/50"
      >
        {brands.map(brand => (
          <option key={brand.brand_id} value={brand.brand_id}>
            {brand.brand_name || brand.name || brand.brand_id}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SimpleBrandSelector;